module.exports = __webpack_public_path__ + "static/media/cloud-showers-heavy.feeb7d55.svg";